import { IHeaderParams } from "ag-grid-community";
import { InfoTooltip } from "@/ui/molecules/InfoTooltip";

interface HeaderWithTooltipParams {
    tooltipText: string;
}

export function HeaderWithTooltip(
    props: IHeaderParams & HeaderWithTooltipParams,
) {
    const tooltipText =
        props.tooltipText ||
        (props as any).tooltipText ||
        props.column?.getColDef()?.headerComponentParams?.tooltipText;

    return (
        <div className="flex items-center gap-2">
            <span className="heading-s">{props.displayName}</span>
            {tooltipText && <InfoTooltip>{tooltipText}</InfoTooltip>}
        </div>
    );
}
